export const categoricalLight = ['#2a78d6', '#eb6834', '#1baf7a', '#eda100', '#e87ba4', '#008300'];

export const categoricalDark = ['#3987e5', '#d95926', '#199e70', '#c98500', '#d55181', '#008300'];

export const sequentialLight = ['#86b6ef', '#4f92e0', '#2a78d6', '#1a5aa8', '#0d366b'];

export const sequentialDark = ['#8cbcf2', '#5d9ae6', '#3987e5', '#276cbe', '#184f95'];

export const statusColors = {
  good: '#0ca30c',
  warning: '#fab219',
  serious: '#d03b3b',
  neutral: '#898781',
};

const isDark = (theme) => theme === 'dark' || theme === true;

export function getCategorical(theme) {
  return isDark(theme) ? categoricalDark : categoricalLight;
}

export function getSequential(theme) {
  return isDark(theme) ? sequentialDark : sequentialLight;
}

export function getCategoricalColor(theme, index) {
  const palette = getCategorical(theme);
  return palette[index % palette.length];
}

export function getSequentialColor(theme, index, total = 5) {
  const palette = getSequential(theme);
  if (total <= 1) return palette[palette.length - 1];
  const position = Math.round((index / (total - 1)) * (palette.length - 1));
  return palette[Math.min(Math.max(position, 0), palette.length - 1)];
}
